module.exports = __webpack_public_path__ + "static/media/top-bg.bb3f6943.png";